interface SliderTooltipProps {
  value: number;
}

export default function SliderTooltip({ value }: SliderTooltipProps) {
  const leftPosition = (value / 800) * 100 + '%';
  return (
    <div
      className="absolute text-[15px] short:!text-[14px] md:text-base text-white bg-[#3C3C3C] p-3 rounded min-w-[50px] md:min-w-[64px] text-center mt-[-75px] short:!mt-[-75px] md:mt-[-90px] ml-[-47px] short:!ml-[-43px] md:ml-[-57px]"
      style={{
        left: leftPosition,
        lineHeight: 1,
      }}>
      {`$${value}`}
      <span className="arrow-down"></span>
    </div>
  );
}
